import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiUserGroup, HiCake, HiDocumentDuplicate, HiHeart, HiExclamationCircle, HiLightBulb, HiShieldCheck } from 'react-icons/hi2';
import SectionTitle from '../components/SectionTitle';
import InfoBox from '../components/InfoBox';
import TabGroup, { TabPanel } from '../components/TabGroup';

const CivilFamily = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <SectionTitle level={1} icon={HiUserGroup}>
        {t('civilFamily.title')}
      </SectionTitle>

      <TabGroup>
        {/* TAB 1: VOS DROITS */}
        <TabPanel tabId="rights">
          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('civilFamily.rightsTitle')}
            </SectionTitle>
            <div className="bg-teal-50 dark:bg-teal-900/20 border-l-4 border-teal-600 dark:border-teal-400 p-4 rounded-r-lg">
              <ul className="space-y-3">
                {t('civilFamily.rightsItems', { returnObjects: true }).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1 font-bold">✓</span>
                    <span className="text-gray-900 dark:text-white font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section>
            <SectionTitle level={2} icon={HiDocumentDuplicate}>
              {t('civilFamily.civilStatusRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('civilFamily.civilStatusRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiHeart}>
              {t('civilFamily.familyRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('civilFamily.familyRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 2: DÉMARCHES */}
        <TabPanel tabId="procedures">
          <section>
            <SectionTitle level={2} icon={HiCake}>
              {t('civilFamily.birthTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('civilFamily.birthItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiDocumentDuplicate}>
              {t('civilFamily.filiationTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('civilFamily.filiationItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiHeart}>
              {t('civilFamily.marriageTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('civilFamily.marriageItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiLightBulb}>
              {t('civilFamily.adviceTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('civilFamily.adviceItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 3: SI PROBLÈME */}
        <TabPanel tabId="problems">
          <InfoBox type="conseil" title={t('civilFamily.lossTitle')}>
            <p>{t('civilFamily.lossContent')}</p>
          </InfoBox>

          <section>
            <SectionTitle level={2} icon={HiExclamationCircle}>
              {t('civilFamily.problemsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('civilFamily.problemsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-orange-600 dark:text-orange-400 mr-2 mt-1">!</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="danger" title={t('civilFamily.urgentTitle')}>
            <p>{t('civilFamily.urgentContent')}</p>
          </InfoBox>
        </TabPanel>
      </TabGroup>
    </div>
  );
};

export default CivilFamily;
